import { render, staticRenderFns } from "./MainDates.vue?vue&type=template&id=c23c2f82&scoped=true"
var script = {}
import style0 from "./MainDates.vue?vue&type=style&index=0&id=c23c2f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23c2f82",
  null
  
)

export default component.exports